module.exports = __webpack_public_path__ + "static/img/success.fc6984a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success.png
// module id = mzrL
// module chunks = 15